import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" eyebrow="The fine print" effectiveDate="February 6, 2026">
      <p>
        Welcome to My Daily Prayer. By using the app you agree to these simple
        terms. We've kept them short and honest.
      </p>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Using the service</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>My Daily Prayer is provided free of charge as a personal prayer journal.</li>
        <li>You must be at least 13 years old to create an account.</li>
        <li>Please don't use the service for anything unlawful, harmful, or intended to hurt others.</li>
        <li>Don't attempt to break, probe, or scrape the service, or upload material that infringes on someone else's rights.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Your account &amp; content</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>You are responsible for what you write in your prayer journal.</li>
        <li>Everything you write stays private to your account — we don't share it publicly.</li>
        <li>You can delete your account at any time from the user menu, and all your content will be permanently removed.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Availability &amp; changes</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>We aim to keep the app available, but we don't guarantee uninterrupted service.</li>
        <li>We may occasionally update or improve features, or make changes to keep the app safe.</li>
        <li>If we make material changes to these terms, we'll do our best to let you know.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Disclaimer &amp; liability</h2>
      <p>
        My Daily Prayer is offered "as is," without warranty of any kind.
        The app is a personal journal — it is not a substitute for pastoral,
        medical, or professional counsel. To the maximum extent permitted by
        law, we are not liable for any indirect or consequential loss arising
        from your use of the service.
      </p>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Contact</h2>
      <p>
        Questions? Email{" "}
        <a className="text-[#9B8BAF] underline underline-offset-4" href="mailto:hello@my-daily-prayer.org">hello@my-daily-prayer.org</a>{" "}
        or use the Contact page.
      </p>
    </LegalPage>
  );
}
